import Axios from '../../../utils/tms-axios/tms-axios';

export const NakshatramSubTempleService = {
  getAll: async (nakshatramId, page = 1, limit = 10) => {
    const resp = await Axios.get(
      `/v1/nakshatram-sub-temple/all/${nakshatramId}`,
      {
        params: {
          page: page,
          limit: limit,
        },
      }
    );

    return resp.data;
  },

  create: async (nakshatramId, subTempleIds) => {
    const resp = await Axios.post(`/v1/nakshatram-sub-temple/create`, {
      nakshatramId,
      subTempleIds,
    });

    return resp.data;
  },

  delete: async (id) => {
    const resp = await Axios.delete(
      `/v1/nakshatram-sub-temple/delete/${id}`,
      {}
    );

    return resp.data;
  },
};
